import axios from "axios";
import { API } from "./api";

const KEY = (slug) => `dk_cc_token_${slug}`;
export const ccToken = (slug) => localStorage.getItem(KEY(slug)) || "";
export const setCcToken = (slug, t) => (t ? localStorage.setItem(KEY(slug), t) : localStorage.removeItem(KEY(slug)));

export function ccApi(slug) {
  const inst = axios.create({ baseURL: `${API}/community-course/courses/${slug}` });
  inst.interceptors.request.use((config) => { const t = ccToken(slug); if (t) config.headers.Authorization = `Bearer ${t}`; return config; });
  return inst;
}
export const ccBase = (slug) => `/learn/${slug}`;
export const ccError = (e) => { const d = e.response?.data?.detail; return Array.isArray(d) ? d.map((x) => x.msg?.replace(/^Value error, /, "")).join(" ") : d || "Something went wrong. Please try again."; };
export const naira = (n) => `₦${Number(n || 0).toLocaleString("en-NG", { maximumFractionDigits: 0 })}`;

export async function downloadCcCertificate(slug, serial) {
  const r = await ccApi(slug).get("/certificate.pdf", { responseType: "blob" });
  const url = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = url; a.download = `${serial}.pdf`; a.click(); URL.revokeObjectURL(url);
}
